import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/696e0a131beda80014d10e92/blockp2p/src/app/homepage/components/CTASection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeroSection"] */ "/home/ubuntu/download/696e0a131beda80014d10e92/blockp2p/src/app/homepage/components/HeroSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/696e0a131beda80014d10e92/blockp2p/src/app/homepage/components/HomepageInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/696e0a131beda80014d10e92/blockp2p/src/app/homepage/components/OfficeLocationSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/696e0a131beda80014d10e92/blockp2p/src/components/common/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/696e0a131beda80014d10e92/blockp2p/src/components/common/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/696e0a131beda80014d10e92/blockp2p/src/components/common/WhatsAppFloatingButton.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/696e0a131beda80014d10e92/blockp2p/src/components/ui/AppIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/696e0a131beda80014d10e92/blockp2p/src/components/ui/AppImage.tsx");
